import { Stack } from '@chakra-ui/react';
import { RiMenu2Fill, RiDashboardLine } from 'react-icons/ri';
import { FiPlusCircle, FiClipboard } from 'react-icons/fi';

import { NavLink } from '../NavLink';
import { NavSection } from '../NavSection';

export function SidebarNavQuality() {
  return (
    <Stack spacing="12" align="flex-start">
      <NavSection title="GERAL">
        <NavLink to="/menu" icon={RiMenu2Fill}>
          Menu
        </NavLink>

        <NavLink to="/quality-control" icon={RiDashboardLine}>
          Dashboard
        </NavLink>
      </NavSection>

      <NavSection title="CONTROLE DE QUALIDADE">
        <NavLink to="/quality-control/new" icon={FiPlusCircle}>
          Registrar NC
        </NavLink>

        <NavLink to="/quality-control/non-conformities" icon={FiClipboard}>
          Não Conformidades
        </NavLink>
      </NavSection>
    </Stack>
  );
}
